import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ImageDestinationForm from './imageDestinationForm';
import { setTourEnabled } from '../../../js/actions/tourActionCreators';
import Joyride from 'react-joyride';
import { JoyrideStepStyle } from '../../common/Joyride/steps';

const steps = [{
    title: 'Select a destination',
    text: 'Images will need to be stored on a file share that clones will be able to access.', // supports html tags
    selector: '.control-holder',
    position: 'left',
    type: 'hover',
    isFixed: true,
    style: JoyrideStepStyle,
}];

const ImageDestinationPage = React.createClass({
    getInitialState: function () {
        return {
            initialFormValues: {
            }
        };
    },
    
    tourCallback(value) {
        if (value && value.type === 'finished' && value.isTourSkipped) {
            this.props.setTourEnabled('dashboard', false);
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'skippedImageDestination',
                    eventLabel: 'Skipped tour on image destination'
                });
        }
        if (value && value.type === 'finished' && !value.isTourSkipped) {
            ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'finishedImageDestination',
                    eventLabel: 'End of Image Destination tour'
                });
        }
    },

    render: function () {
        return (
            <div className="content-container">
                <Joyride ref="joyride" run={this.props.tourEnabled} autoStart={true} showSkipButton={true} type="continuous" steps={steps} callback={this.tourCallback} debug="true" locale={{ last: 'Next', next: 'Next', skip: 'Skip', back: 'Back' }}/>
                <ImageDestinationForm initialValues={this.state.initialFormValues} />
            </div>
        );
    }
});

ImageDestinationPage.title = 'Destination';

const mapStateToProps = (state) => {
    return {
        tourEnabled: state.tour.dashboard
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setTourEnabled: (tour, enabled) => {
            dispatch(setTourEnabled(tour, enabled));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageDestinationPage);


// WEBPACK FOOTER //
// ./src/components/imaging/ImageDestinationPage/index.jsx